import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import { withStyles } from 'material-ui';
import CheckboxStyles from './ListCheckboxStyles';
import UncheckedIcon from '../../icons/UncheckedIcon';
import CheckedIcon from '../../icons/CheckedIcon';

const CheckboxWrapper = ({ selected, classes }) => (
  <Checkbox
    checked={selected}
    tabIndex={-1}
    disableRipple
    classes={classes.checkboxStyles}
    icon={<UncheckedIcon />}
    checkedIcon={<CheckedIcon />}
  />
);

CheckboxWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  selected: PropTypes.bool,
};

export default withStyles(CheckboxStyles)(CheckboxWrapper);



// WEBPACK FOOTER //
// ./src/components/checkbox/ListCheckbox.js